<!--
Wraps html content in a Bootstrap modal popup
Usage:
  <ModalPopup id="foo" title="Bar">
    Some html content goes here
  </ModalPopup>
@author bmk11u
-->
<template>
  <div class="modal fade" :id="id + 'Modal'" tabindex="-1" role="dialog" :aria-labelledby="id + 'ModalLabel'" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content" style="border-radius: 20px;">
        <div class="modal-header bg-uog-dark-blue text-white">
          <h5 class="modal-title" :id="id + 'ModalLabel'">{{ title }}</h5>
          <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalPopup',
  props: [ 'id', 'title' ]
}
</script>
